export enum PaymentGatewayWorkspaceCapabilityAccessOperation {
    create = "56000a48-0276-40b6-8a8e-73635d041d75",
    read = "021ac788-ce41-46c7-81f5-e5968206e783",
    update = "ecb4474e-eaf4-4305-b841-15cfa436f011",
    delete = "fc351316-3ba0-4fea-b8a2-9a31ee490aa6",
}
